import { render, staticRenderFns } from "./Tcdt.vue?vue&type=template&id=02071641&scoped=true&"
import script from "./Tcdt.vue?vue&type=script&lang=js&"
export * from "./Tcdt.vue?vue&type=script&lang=js&"
import style0 from "./Tcdt.vue?vue&type=style&index=0&id=02071641&lang=less&scoped=true&"
import style1 from "./Tcdt.vue?vue&type=style&index=1&id=02071641&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02071641",
  null
  
)

export default component.exports